
/**
 * Performance optimization utilities
 */

// Resource hints for critical third-party resources
export const setupResourceHints = () => {
  // Add preconnect for important domains
  const criticalDomains = [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
    'https://cdn.gpteng.co'
  ];
  
  criticalDomains.forEach(domain => {
    if (!document.querySelector(`link[rel="preconnect"][href="${domain}"]`)) {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      document.head.appendChild(link);
    }
  });
};

// Defer non-critical JavaScript
export const deferNonCriticalJS = () => {
  // Scripts to defer
  const scriptsToDefer = [
    // Add paths to non-critical scripts
  ];
  
  scriptsToDefer.forEach(scriptPath => {
    const script = document.createElement('script');
    script.src = scriptPath;
    script.defer = true;
    document.body.appendChild(script);
  });
};

// Setup page performance optimizations
export const setupPerformanceOptimizations = () => {
  setupResourceHints();
  
  // Defer loading of below-the-fold content
  if (typeof window !== 'undefined') {
    // Only run in browser environment
    window.addEventListener('load', () => {
      // Defer non-critical JS
      deferNonCriticalJS();
      
      // Lazy load images
      import('@/utils/imageOptimizer').then(module => {
        module.setupLazyLoading();
      });
    });
  }
};
